import { Component, HostBinding, OnInit, OnDestroy } from '@angular/core';
import { SettingsService } from 'src/app/services/settings.service';
import { WidgetService } from 'src/app/services/widget.service';
import { IdentityService } from 'src/app/services/identity.service';
import { MenubarService } from 'src/app/services/menubar.service';
import { WidgetConfigService } from 'src/app/services/widget-config.service';

@Component({
    selector: 'app-chat-page',
    templateUrl: './chat-page.component.html',
    styleUrls: ['./chat-page.component.scss'],
    standalone: false
})
export class ChatPageComponent implements OnInit, OnDestroy {
  @HostBinding('class.menubar-top')
  private get _menubarTop() {
    return this.menubarPosition === 'top';
  }

  @HostBinding('class.menubar-left')
  private get _menubarLeft() {
    return this.menubarPosition === 'left';
  }

  public openWidget?: WidgetService.SplitViewWidget;

  public get menubarPosition() {
    return this._settings.menubarPosition;
  }

  private _addWidget(widgetName: WidgetService.WidgetName): void {
    // Define context-specific handlers for chat mode
    const contextHandlers = {
      onEditFile: (event: any) => this._openMonacoWidget(event.path),
      onEditWorkflow: (event: any) => {
        // Open WorkflowWidget for visual workflow editing (JSON files)
        console.log('onEditWorkflow event:', event);
        this._openWorkflowWidget(event.name);
      },
      onEditMCPConfig: (event: any) => this._openMonacoWidget(event.path)
    };

    // Get widget-specific configuration
    const config = this._widgetConfigService.getWidgetConfig(widgetName, 'chat', contextHandlers);

    this.openWidget = {
      component: WidgetService.REGISTRY[widgetName],
      inputs: {
        teamName: this.teamName,
        ...config.inputs
      },
      outputs: {
        onClose: () => (this.openWidget = undefined),
        ...config.outputs
      }
    };
  }

  private _openMonacoWidget(path: string): void {
    this.openWidget = {
      component: WidgetService.REGISTRY['MonacoWidget'],
      inputs: {
        teamName: this.teamName,
        path: path,
        title: path?.split('/').pop() || 'Untitled'
      },
      outputs: {
        onClose: () => (this.openWidget = undefined)
      }
    };
  }

  private _openWorkflowWidget(name: string): void {
    // Get the configuration for WorkflowWidget to handle its events
    const contextHandlers = {
      onEditFile: (event: any) => this._openMonacoWidget(event.path)
    };
    const config = this._widgetConfigService.getWidgetConfig('WorkflowWidget', 'chat', contextHandlers);
    
    this.openWidget = {
      component: WidgetService.REGISTRY['WorkflowWidget'],
      inputs: {
        teamName: this.teamName,
        name: name
      },
      outputs: {
        onClose: () => (this.openWidget = undefined),
        ...config.outputs
      }
    };
  }

  public get teamName(): string | null {
    return this._identity.me?.selectedTeamName ?? null;
  }

  constructor(
    private readonly _settings: SettingsService,
    private readonly _identity: IdentityService,
    private readonly _menubarService: MenubarService,
    private readonly _widgetConfigService: WidgetConfigService
  ) {}

  ngOnInit() {
    // Hide the menubar when entering full-screen chat mode
    this._menubarService.showMenubar = false;
  }

  ngOnDestroy() {
    // Restore the menubar when leaving full-screen chat mode
    this._menubarService.showMenubar = true;
  }

  public $openWidget(widgetName: WidgetService.WidgetName): void {
    this._addWidget(widgetName);
  }

  public $openAgentSettings(event: { agentId: string | null }): void {
    this.openWidget = {
      component: WidgetService.REGISTRY['AgentSettingsWidget'],
      inputs: {
        teamName: this.teamName,
        agentId: event.agentId
      },
      outputs: {
        onClose: () => (this.openWidget = undefined),
        onAgentSaved: () => (this.openWidget = undefined),
        onAgentDeleted: () => (this.openWidget = undefined)
      }
    };
  }
}
